/**
 * SIDEBAR TOKENS
 * Source: 🎨 Figma — components-rentals export
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createSidebarTokens(s: SemanticTokens) {
  return {
  bgDefault: s.surface.ground,               // --sidebar-item-bg-default: var(--surface-ground)
  bgHover: s.interactive.primary.subtle,     // --sidebar-item-bg-hover: var(--color-rentals-50)
  bgActive: s.interactive.primary.subtle,    // --sidebar-item-bg-active: var(--color-rentals-50)
  bgDisabled: s.surface.disabled,            // --sidebar-item-bg-disabled: var(--surface-disabled)
  fgDefault: s.text.secondary,               // --sidebar-item-fg-default: var(--text-secondary)
  fgHover: s.text.secondary,                 // --sidebar-item-fg-hover: var(--text-secondary)
  fgActive: s.text.primary,                  // --sidebar-item-fg-active: var(--text-primary)
  };
}
export const sidebarTokens = createSidebarTokens(SEMANTIC);